<template>
  <div>
    <div
      class="mt-3 flex "
      :class="{'flex-between' :valueItem.decisionStatus}">
      <div>
        <b
          class="additional-dtek__fio"
          :data-qa="`additional-dtek-${valueIndex}-fio`">{{ valueItem.fio }}</b>
        <span
          class="additional-dtek__date ml-2"
          :data-qa="`additional-dtek-${valueIndex}-date`">{{ $d(new Date(valueItem.datetime), "shortDate") }} {{ $d(new Date(valueItem.datetime), "time") }}</span>
      </div>
      <StatusChip
        class="font-size-12 px-2 ml-auto"
        :data-qa="`additional-dtek-${valueItem.decisionStatus}`"
        :name="valueItem.decisionStatus==='Considered' ? $t('Common.Considered') : $t('Common.NotConsidered')"
        :status="valueItem.decisionStatus==='Considered' ? 'Success' : 'Decline'"/>
    </div>
    <template v-if="(showHistory && valueItem.decisionStatus !== 'NotConsidered') || (valueItem.decisionStatus && valueItem.decisionStatus==='Considered')">
      <div
        v-for="(answerItem, answerIndex) in valueItem.answers"
        :key="`${valueIndex}-answer-${answerIndex}`"
        class="additional-dtek__answer">
        <div>
          <b
            class="additional-dtek__answer-question"
            :data-qa="`additional-dtek-${valueIndex}-answers-${answerIndex}-question`">{{ answerItem.question }}</b>
          <div
            v-if="answerItem.response"
            class="additional-dtek__answer-response"
            :data-qa="`additional-dtek-${valueIndex}-answers-${answerIndex}-response`">
            {{ answerItem.response }}
          </div>
        </div>
        <StatusChip
          class="font-size-12 px-2 ml-auto"
          :data-qa="`additional-dtek-${valueIndex}-answers-${answerIndex}-status`"
          :name="answerItem.conclusion ? $t('Common.Answers') : $t('Common.NotAnswers')"
          :status="answerItem.conclusion ? 'Success' : 'Decline'"/>
      </div>
    </template>
  </div>
</template>
<script>
import StatusChip from 'components/common/elements/StatusChip.vue'

export default {
  name: 'AditionalFieldsDtekItem',
  components: {
    StatusChip,
  },
  props: {
    valueIndex: {
      type: Number
    },
    valueItem: {
      type: Object
    },
    showHistory: {
      type: Boolean
    }
  },
}
</script>
<style scoped lang="scss">
.additional-dtek {
  &__fio {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }
  &__answer {
    display: grid;
    grid-template-columns: 1fr 105px;
    margin-top: 10px;
    padding-left: 10px;
    &-question {
      font-weight: 500;
      letter-spacing: 0.022px;
      text-transform: uppercase;
      opacity: 0.5;
    }
    &-response {
      font-size: 14px;
      margin-top: 5px;
      font-weight: 600;
    }
  }
}
</style>
